(function() {
  angular.module('dso')
  .controller('dsoAdminEditUserController', ['$uibModal', 'DsoUsers', '$scope','$filter','$timeout', 'gridServices', 'uiGridConstants', 'adminUsers',
   'secSecurityService', '$state', '$stateParams',
    function($uibModal, DsoUsers, $scope, $filter, $timeout, gridServices, uiGridConstants, Users, securityService,
      $state, $stateParams) {
      var vm = this;
      vm.user = _.clone($stateParams.user);
      vm.user.locations = [];
      vm.email = vm.user.unverifiedEmail ? vm.user.unverifiedEmail : vm.user.verifiedEmail;
      vm.mode = $stateParams.mode;
      vm.selfView = $stateParams.selfView;
      vm.running = false;
      vm.userManipulated = false;
      vm.close = close;
      vm.deleteAdmin = deleteAdmin;
      vm.submit = submit;
      vm.emailResent = false;
      securityService.hasAnyAuthority('PREVIOUS_ADMINISTRATOR').then((val) => {
        vm.inUserView = val;
      });

      vm.gridRunning = true;
      if(vm.mode === 'edit'){
        vm.auditEventsPromise = Users.getAuditEvents({userId: vm.user.userId}).$promise;
      }

      $scope.$watch('vm.user', (change) => {
        if(change) {
          vm.userManipulated = true;
        }
      }, true);

      $scope.$watch('errorControl', function() {
        $scope.errorControl && $scope.errorControl.showErrors('uniqueEmailAddress');
      });

      function submit() {
        $scope.errorControl.showErrors();
        if ($scope.addDsoUserForm.$valid) {
          if (vm.user.addUserMode) {
            delete vm.user.addUserMode;
          }
          if (vm.mode === 'edit') {
            if (vm.userManipulated) {
              vm.running = true;
              DsoUsers.updateUser(vm.user, () => {
                $scope.errorControl.hideErrors();
                $scope.dnConfirmationMessage.$show("Administrator has been successfully updated.");
              }, (error) => {
                vm.running = false;
                throw error;
              });
            }
          }
        }
      }

      function deleteAdmin() {
        vm.deleting = true;
        $uibModal.open({
          controller:['$uibModalInstance', 'user', '$scope', function($uibModalInstance, user, $scope) {
            var self = this;
            self.user = user;
            self.delete = function() {
              $uibModalInstance.close(true);
            };
            self.close = function() {
              $uibModalInstance.dismiss();
            };
            $scope.$on('authenticationChanged', () => {
              $uibModalInstance.dismiss();
            });
          }],
          templateUrl: '/js/admin/confirmDelete.html' + appVersion,
          size: 'sm',
          animation: false,
          controllerAs: 'confirmation',
          resolve: {
            user: () => vm.user
          }
        }).result.then(function(val) {
          if (val) {
            DsoUsers.deleteUser({id: vm.user.id}, function() {
              var msg = '';
              if (vm.user.userId) {
                msg = 'Admin '+ vm.user.userId + ' has been deleted.', 'danger';
              } else {
                msg = 'Admin has been deleted.', 'danger';
              }
              $scope.dnConfirmationMessage &&
              $scope.dnConfirmationMessage.$show(msg)
                .then(() => {
                  vm.deleting = false;
                  $state.go("dsoAdmin.users", {refresh: 'admins'});
                });
            });
          }
        }, angular.noop);
      }
      vm.previous = function previous() {
        $state.go('dsoAdmin.users', {refresh: 'admins'});
      };

    }]);
})();
